var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingFaQbutton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_15752",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 15752",
    transform: "translate(-336 -581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Layer_2",
    d: "M14.946,2A12.946,12.946,0,1,0,27.893,14.946,12.984,12.984,0,0,0,14.946,2Zm0,19.419a1.295,1.295,0,0,1,0-2.589,1.295,1.295,0,1,1,0,2.589Zm1.295-5.179a1.392,1.392,0,0,1-1.295,1.295,1.392,1.392,0,0,1-1.295-1.295v-.906a1.244,1.244,0,0,1,.906-1.165l.906-.259a1.132,1.132,0,0,0,.777-1.165,1.16,1.16,0,0,0-1.165-1.165h-.129a1.6,1.6,0,0,0-1.036.518,1.273,1.273,0,0,1-1.812.388,1.45,1.45,0,0,1-.388-1.942,3.813,3.813,0,0,1,3.107-1.683h.129A3.757,3.757,0,0,1,18.7,12.616,3.509,3.509,0,0,1,16.241,16.241Z",
    transform: "translate(336.999 582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_10550",
    "data-name": "\\u9577\\u65B9\\u5F62 10550",
    width: 32,
    height: 32,
    transform: "translate(336 581)",
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingFaQbutton);
export default __webpack_public_path__ + "static/media/settingFAQbutton.fd64cc4863c8b18af68ede68904ed2a5.svg";
export { ForwardRef as ReactComponent };